import { render, staticRenderFns } from "./aiToolChild.vue?vue&type=template&id=6dd7f31f&scoped=true"
import script from "./aiToolChild.vue?vue&type=script&lang=js"
export * from "./aiToolChild.vue?vue&type=script&lang=js"
import style0 from "./aiToolChild.vue?vue&type=style&index=0&id=6dd7f31f&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd7f31f",
  null
  
)

export default component.exports